import { head, isArray, isNil } from 'lodash/fp';

import uniqueContentWithDraftPrecedence from '../unique-content-with-draft-precedence';
import type { ItemTypename, TableOfContentsData, TableOfContentsItems } from '../use-table-of-contents/types';

const isDefined = <T>(value: T | null | undefined): value is T => !isNil(value);

const getTableOfContentsItems = <
  TData extends TableOfContentsData,
  TTypename extends ItemTypename | undefined = undefined,
>(
  data: TData | undefined,
  typename?: TTypename,
): TableOfContentsItems<TData, TTypename> => {
  const tableOfContentsLists = uniqueContentWithDraftPrecedence(
    isArray(data?.allTableOfContentsList) ? data.allTableOfContentsList.filter(isDefined) : [],
  );
  const rawItems = head(tableOfContentsLists)?.items;
  const items = isArray(rawItems) ? rawItems.filter(isDefined) : [];
  const filteredItems = typename ? items.filter((entry) => entry.item?.__typename === typename) : items;

  return filteredItems as TableOfContentsItems<TData, TTypename>;
};

export default getTableOfContentsItems;
